import axios from './client';

const SEARCH = '/managers';
const SEARCH_ONE = '/manager';

export function search(filters = {}) {
  return axios.get(SEARCH, { filters });
}

export function searchOne(filters = {}) {
  return axios.get(SEARCH_ONE, { params: filters });
}
